import { Box, Button, Icon, MessageBubble, styled, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useMemo } from "react"
import { ProductGroupMetaData } from "../../../../../data"
import { Message, useOpenArticleListWithProductGroup, useOpenFastCalcProductGroup } from "../../../../../data/hooks"

type Props = {
    initialMetadata: ProductGroupMetaData
    isOwnMessage: boolean
    message: Message
}

const List = styled("ul")({
    alignSelf: "flex-start",
    fontSize: "12px",
    listStyleType: "disc",
    paddingInlineStart: "40px",
    marginBlockStart: "1em",
})

const ActionContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    marginTop: theme.spacing(1),
    "> *": {
        margin: theme.spacing(0.5),
    },
}))

export function ProductGroupRequest(props: Props) {
    const { isOwnMessage, initialMetadata, message } = props
    const { translateText, formatDate } = useLocalization()

    const { productGroups, productGroupIds } = useMemo(() => {
        return {
            productGroups: initialMetadata.productGroups?.map((pG) => pG.productGroupName),
            productGroupIds: initialMetadata.productGroups?.map((pG) => pG.productGroupId),
        }
    }, [initialMetadata])

    const { handleFastCalculatorClick } = useOpenFastCalcProductGroup(message.chatId, productGroupIds, initialMetadata.vehicleInfo?.id)
    const { handleOpenArticleListWithProductGroups } = useOpenArticleListWithProductGroup(
        message.chatId,
        productGroupIds,
        initialMetadata.vehicleInfo?.id
    )

    return (
        <MessageBubble left={!isOwnMessage} headline={translateText(14074)} dateTime={formatDate(new Date(message.inserted), "g")}>
            <Box>
                <Typography variant="h4">{translateText(14075)}</Typography>
                {message.text}

                {productGroups && (
                    <>
                        <Typography variant="h4" marginTop="1em">
                            {translateText(755)}
                        </Typography>

                        <List>
                            {productGroups.map((e) => {
                                return <li key={e}>{e}</li>
                            })}
                        </List>
                    </>
                )}

                <ActionContainer>
                    {handleOpenArticleListWithProductGroups && (
                        <div>
                            <Button onClick={handleOpenArticleListWithProductGroups} startIcon={<Icon name="check" />}>
                                {translateText(1041)}
                            </Button>
                        </div>
                    )}
                    {handleFastCalculatorClick && (
                        <div>
                            <Button variant="outlined" onClick={handleFastCalculatorClick} startIcon={<Icon name="fastclick" />}>
                                {translateText(1042)}
                            </Button>
                        </div>
                    )}
                </ActionContainer>
            </Box>
        </MessageBubble>
    )
}
